import * as React from 'react'

const SvgSubscriptionIcon = ({ stroke }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 7.20001H7.01M1 4.40001L1 8.87453C1 9.36371 1 9.6083 1.05526 9.83847C1.10425 10.0425 1.18506 10.2376 1.29472 10.4166C1.4184 10.6184 1.59135 10.7914 1.93726 11.1373L9.60589 18.8059C10.7939 19.9939 11.388 20.588 12.0729 20.8105C12.6755 21.0063 13.3245 21.0063 13.927 20.8105C14.612 20.588 15.2061 19.9939 16.3941 18.8059L18.6059 16.5941C19.7939 15.4061 20.388 14.812 20.6105 14.1271C20.8063 13.5245 20.8063 12.8755 20.6105 12.273C20.388 11.588 19.7939 10.9939 18.6059 9.8059L10.9373 2.13727C10.5914 1.79137 10.4184 1.61842 10.2166 1.49473C10.0376 1.38507 9.84253 1.30427 9.63846 1.25527C9.40829 1.20001 9.1637 1.20001 8.67452 1.20001L4.2 1.20001C3.0799 1.20001 2.51984 1.20001 2.09202 1.418C1.7157 1.60975 1.40973 1.91571 1.21799 2.29203C1 2.71985 1 3.27991 1 4.40001ZM7.5 7.20001C7.5 7.47615 7.27614 7.70001 7 7.70001C6.72386 7.70001 6.5 7.47615 6.5 7.20001C6.5 6.92387 6.72386 6.70001 7 6.70001C7.27614 6.70001 7.5 6.92387 7.5 7.20001Z"
      stroke={stroke || "#A4BCFD"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgSubscriptionIcon
